import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { hoursToDurationFormat } from '../../utils/date';

// Composant pour afficher les heures avec icône
export const HoursDisplay: React.FC<{
    value: number | string;
    icon: any;
    colorClass?: string;
    label?: string;
}> = ({ value, icon, colorClass = '', label }) => (
    <CellValueWithIcon value={hoursToDurationFormat(Number(value))} icon={icon} colorClass={colorClass} label={label} />
);

export const CellValueWithIcon: React.FC<{
    value: number | string;
    icon: any;
    colorClass?: string;
    label?: string;
}> = ({ value, icon, colorClass = '', label }) => {
    const isEmpty = !value || value === '0' || value === '00h00';
    const textClass = isEmpty ? 'text-black opacity-40 flex items-center' : 'text-black flex items-center';
    return (
        <div className={textClass}>
            {value}
            <FontAwesomeIcon icon={icon} className={'ml-1 ' + colorClass} title={label} />
        </div>
    );
};
